
up.compiler('#select_ftag', function(element, data) {
  const select_ftag = new Choices(element, {
    choices: data.map((e) => {return {value: e.slug, label: e.fr_name}}),
    placeholder: true,
    placeholderValue: 'Catégorie',
    removeItemButton: true,
    classNames: {
      containerOuter: ['choices', 'w-96']
    },
  });

  element.addEventListener('addItem',
    function(event) {
      up.render({ url: `/fresks?category=${event.detail.value}`, target: '#fresks_cards', history: true, focus: '#select_ftag' })
    },
    false,
  );

  element.addEventListener('removeItem',
    function() {
      up.render({ url: `/fresks`, target: '#fresks_cards', history: true, focus: '#select_ftag_container' })
    },
    false,
  );

  
  return () => {
    select_ftag.destroy()
  }
})